import React from "react"
import { withTheme } from "emotion-theming"
import { ResponsiveBar } from "@nivo/bar"
import { readableColor } from "polished"

import { volunteerParticipation } from "@data/volunteer-participation"

import { Label, Tooltip, Wrapper } from "./styles"

const BarComponent = props => {
  return (
    <g transform={`translate(${props.x},${props.y})`}>
      <rect
        x={-3}
        y={7}
        width={props.width}
        height={props.height}
        fill="rgba(0, 0, 0, .07)"
      />
      <rect width={props.width} height={props.height} fill={props.color} />
      <rect
        x={props.width - 5}
        width={5}
        height={props.height}
        fill={props.borderColor}
        fillOpacity={0.2}
      />
      <text
        x={props.width - 16}
        y={props.height / 2}
        textAnchor="end"
        dominantBaseline="central"
        fill={readableColor(props.color)}
        style={{
          fontWeight: 600,
          fontSize: 20,
        }}
      >
        {props.data.value}
      </text>
    </g>
  )
}

const VolunteerParticipation = ({ theme, colour }) => (
  <Wrapper height="350px">
    <ResponsiveBar
      data={volunteerParticipation}
      indexBy="Year"
      keys={["Volunteers"]}
      margin={{ bottom: 20, left: 120 }}
      padding={0.2}
      layout="horizontal"
      colors={[
        theme.colours.lightPrimary,
        theme.colours.secondary,
        theme.colours.success,
      ]}
      barComponent={BarComponent}
      colorBy="index"
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        renderTick: tick => (
          <g key={tick.key} transform={`translate(${tick.x - 10},${tick.y})`}>
            <text
              textAnchor="end"
              dominantBaseline="middle"
              transform={`translate(${tick.textX},${tick.textY})`}
              style={{
                fill: colour || theme.color,
                fontSize: 18,
                fontWeight: 700,
              }}
            >
              {tick.value}
            </text>
          </g>
        ),
      }}
      enableGridY={false}
      enableLabel={false}
      labelFormat={d => (
        <Label x={50} textAnchor="start">
          {d}
        </Label>
      )}
      animate={false}
      tooltip={props => <Tooltip>{props.value}</Tooltip>}
    />
  </Wrapper>
)

export default withTheme(VolunteerParticipation)
